import { useGlobalStore } from '@/stores/store';

export function getGlobalStore() {
  return useGlobalStore.getState();
}
